// ============================================================================
// 📦 VERSION: 2025.12.02.1420
// ============================================================================
// ADVERT CONFIG - Central location for all fallback advertisement URLs
// Update these URLs when you have Google AdSense or other ad network codes
// ============================================================================

const advertConfig = {
  // Mobile banner (320x50 or 340x50)
  mobileBanner: {
    url: 'https://via.placeholder.com/340x50/4A5568/FFFFFF?text=Your+Ad+Here',
    clickUrl: 'https://traktag.com/advertise',
    width: 340,
    height: 50
  },
  
  // Desktop banner (728x90)
  desktopBanner: {
    url: 'https://via.placeholder.com/728x90/4A5568/FFFFFF?text=Your+Ad+Here',
    clickUrl: 'https://traktag.com/advertise',
    width: 728,
    height: 90
  },
  
  // Interstitial / Exit ad (full screen)
  interstitial: {
    url: 'https://via.placeholder.com/300x250/4A5568/FFFFFF?text=Your+Ad+Here',
    clickUrl: 'https://traktag.com/advertise',
    width: 300,
    height: 250
  },
  
  // Square ad (for sidebars etc)
  square: {
    url: 'https://via.placeholder.com/250x250/4A5568/FFFFFF?text=Your+Ad+Here',
    clickUrl: 'https://traktag.com/advertise',
    width: 250,
    height: 250
  },

  // ============================================================================
  // GOOGLE ADSENSE SETUP (uncomment and fill in when ready)
  // ============================================================================
  // To use Google AdSense:
  // 1. Sign up at https://www.google.com/adsense
  // 2. Add your site and get approved
  // 3. Create ad units for each size
  // 4. Replace the placeholder URLs above with your ad unit codes
  //
  // Example AdSense format:
  // mobileBanner: {
  //   adClient: 'ca-pub-XXXXXXXXXXXXXXXX',
  //   adSlot: '1234567890',
  //   width: 320,
  //   height: 50
  // }
  // ============================================================================
};

export default advertConfig;
